export default __webpack_public_path__ + "static/media/calls.a9dbd6d2.mp3";